import React from 'react'

import * as S from './card.styled'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  className?: string
}

export const Card = ({ children, className, ...props }: CardProps) => {
  return (
    <S.Card className={className} {...props}>
      {children}
    </S.Card>
  )
}
